import React, { useEffect, useState, useContext, useMemo } from 'react';
import { CollapsibleItem, Icon, Row, Col, Modal, Container } from "react-materialize";
import RequestCard from "./RequestCard";
import EnableRepurpose from './EnableRepurpose/RepurposeModal';
import EmptyIcon from "./img/empty-data.png";
import { axiosClient } from '../api/httpClient';
import InfiniteScroll from 'react-infinite-scroller';
import KanbanFilters from './Home/KanbanView/KanbanViewContent/KanbanFilters';
import { YT_HELPER_SECTION } from '../api/Constants';
import { convertServerToLocalTime, toISODate } from '../api/Util';
import { Spin } from "antd";
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { KanbanDndContext } from './DragNDrop';

const DraggableCard = ({ card, index, droppableId, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transition,
        transform,
        isDragging,
    } = useSortable({
        id: String(card.card_id),
        data: {
            type: 'card',
            card,
            sortable: { containerId: droppableId },
        },
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition: isDragging ? 'none' : transition,
        opacity: isDragging ? 0.5 : 1,
    };
    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            className={`draggable-card ${isDragging ? 'is-dragging' : ''}`}
            style={style}
            data-paused={card.paused}
            data-complete={card.is_complete}
            data-card-id={card.card_id}
            data-card-status={card.card_status}
            data-card-repurpose-status={card.repurpose_status}
            data-ythelper-card-status={card.ytHelper_card_status}
            data-index={index}
            data-revisions={card.revision_nr ? card.revision_nr : 0}
            data-content-id={card.content_id || ""}
            data-done-video-limit={card?.done_video_limit ? card.done_video_limit : "1"}
        >
            {children}
        </div>
    );
};

export default (props) => {
    const [iconState, setIconState] = useState({
        up: false,
        down: true,
        reset: false,
    });
    const [cardData, setCardData] = useState(props.cards || []);
    const [offset, setOffSet] = useState(10);
    const [hasMore, setHasMore] = useState(true);
    const [cardActivityModal, setCardActivityModal] = useState(false);
    const [cardActivityData, setCardActivityData] = useState([]);
    const [cardRepurposeModal, setCardRepurposeModal] = useState(false);
    const [currentCardId, setCurrentCardId] = useState(null);
    const [currentCardRepurpose, setCurrentCardRepurpose] = useState(true);

    useEffect(() => {
        setCardData(props.cards);
        setOffSet(10);
        if( props.cards && props.cards.length<8)
        {
            setHasMore(false);
        }
    }, [props.cards])

    let section = "";
    let dataSection = "";


    if (props.name === "Video Requests") {
        section = "video_request"
        dataSection = "video_requests"
    }
    else if (props.name === "On Hold") {
        section = "on_hold"
        dataSection = "on_hold"
    }
    else if (props.name === "Editing") {
        section = "editing"
        dataSection = "editing"
    }
    else if (props.name === "QA") {
        section = "qa"
        dataSection = "qa_cards"
    }
    else if (props.name === "Done") {
        section = "done"
        dataSection = "done_cards"
    }
    else if (props.name === "Completed") {
        section = "updatedDone"
        dataSection = "updatedDone"
    }
    else if (props.name === "Canceled") {
        section = "canceled"
        dataSection = "cancelled_cards"
    }
    else if (props.name === "Repurposing Done") {
        section = "repurposeDone"
        dataSection = "repurposeDone"
    }
    else if (props.name === "Repurposing QA") {
        section = "repurposeQA"
        dataSection = "repurposeQA"
    }
    else if (props.name === "Repurposing") {
        section = "repurposeEditing"
        dataSection = "repurposeEditing"
    }
    else {
        section = "video_request";
        dataSection = "video_requests";
    }

    if(props?.section === YT_HELPER_SECTION)
    {
        if (props.name === "Assigned") {
            section = "assigne_card"
            dataSection = "assigne_card"
        }
        else if (props.name === "In Progress") {
            section = "inProgress"
        }
        else if (props.name === "Done") {
            section = "inDone"
        }
        else if(props.name === "Cancelled"){
            section = 'cancelled'
        }
    }

    const droppableId = `${props.type ?? 'none'}|${props.rType ?? 'none'}|${props.ytType ?? 'none'}`;
    const { setNodeRef: setDroppableRef, isOver } = useDroppable({ id: droppableId });
    const dndContext = useContext(KanbanDndContext) || {};
    const { activeId, overDroppableId, activeCardData, pendingMoves, dropPosition, pendingReorders, registerColumnList } = dndContext;
    const isOverThisColumn = !!activeId && overDroppableId === droppableId;
    const isColumnHovered = isOver || isOverThisColumn;
    const isActiveCardInThisColumn = cardData?.some((c) => String(c.card_id) === String(activeId)) ?? false;

    let activeCard = null;
    if (activeId) {
        const pendingMove = pendingMoves?.[activeId];
        if (pendingMove?.targetDroppableId === droppableId && pendingMove?.cardData) {
            activeCard = pendingMove.cardData;
        } else if (activeCardData) {
            activeCard = activeCardData;
        } else if (cardData) {
            activeCard = cardData.find((c) => String(c.card_id) === String(activeId));
        }
    }
    const shouldShowPlaceholder = isColumnHovered && activeCard && (!isActiveCardInThisColumn || (dropPosition?.columnId === droppableId));
    const placeholderIndex = dropPosition?.columnId === droppableId ? dropPosition.index : null;

    const getDisplayCards = () => {
        let displayCards = [...(cardData || [])];
        const columnKeyMap = {
            video_requests: 'video_requests', on_hold: 'on_hold', editing: 'editing', qa_cards: 'qa_cards',
            done_cards: 'done_cards', cancelled_cards: 'cancelled_cards', repurposeEditing: 'repurposeEditing',
            repurposeDone: 'repurposeDone', repurposeQA: 'repurposeQA', updatedDone: 'updatedDone', assigne_card: 'assigne_card',
            inProgress: 'inProgress', inDone: 'inDone', cancelled: 'cancelled',
        };
        const columnKey = columnKeyMap[dataSection];
        const hasPendingReorder = columnKey && pendingReorders?.[columnKey];
        if (activeId && isActiveCardInThisColumn && !hasPendingReorder) {
            displayCards = displayCards.filter((c) => String(c.card_id) !== String(activeId));
        }
        Object.keys(pendingMoves || {}).forEach((cardId) => {
            const pending = pendingMoves[cardId];
            const idStr = String(cardId);
            if (pending.targetDroppableId !== droppableId) {
                displayCards = displayCards.filter((c) => String(c.card_id) !== idStr);
            } else if (pending.targetDroppableId === droppableId && pending.cardData) {
                displayCards = displayCards.filter((c) => String(c.card_id) !== idStr);
                displayCards = [{ ...pending.cardData }, ...displayCards];
            }
        });
        if (hasPendingReorder && columnKey) {
            const reorderedIds = pendingReorders[columnKey];
            const cardMap = new Map(displayCards.map((c) => [Number(c.card_id), c]));
            const reordered = reorderedIds.map((id) => cardMap.get(id)).filter(Boolean);
            const idSet = new Set(reorderedIds);
            const rest = displayCards.filter((c) => !idSet.has(Number(c.card_id)));
            displayCards = [...reordered, ...rest];
        }
        return displayCards;
    };
    const displayCards = getDisplayCards();

    const cardIdsKey = useMemo(
        () => (cardData || []).map((c) => String(c.card_id)).join(','),
        [cardData]
    );
    useEffect(() => {
        if (typeof registerColumnList === 'function') {
            registerColumnList(droppableId, cardData || []);
        }
    }, [droppableId, registerColumnList, cardData?.length, cardIdsKey]);

    const fetchMoreCards =()=>{
        let params = props.viewAs ? {
            view_as: props.viewAs
        } : {};
        let obj = {
            offset,
            limit:10,
            section,
            card_name: props.searchText ? props.searchText:""
        }
        if(props.startDate && props.endDate)
        {
            obj = {
                ...obj,
                startDate:toISODate(props.startDate),
                endDate:toISODate(props.endDate),
                selectedDueDate:props.selectedDueDate
            }
        }
        let newOffset = offset+10;
        if(props?.section === YT_HELPER_SECTION)
        {
            axiosClient.post("/api/ythelper/cards",{...params,...obj})
            .then(({data})=>{
                if(data[section].length !== 0 )
                {
                    let allCardData = [...cardData ,...data[section]];
                    setCardData(allCardData);
                    setOffSet(newOffset);
                }
                else{
                    setHasMore(false);
                }
            return;
            })
        }
        else
        {
            axiosClient.post("/api/getCards",{...params,...obj})
            .then(({data})=>{
                if(data[dataSection].length !== 0 )
                {
                    let allCardData = [...cardData ,...data[dataSection]];
                    setCardData(allCardData);
                    setOffSet(newOffset);
                }
                else{
                    setHasMore(false);
                }
            return;
            })
        }
        return
    }

    const filterCardByDate =(dataFilter)=>{
        let params = props.viewAs ? {
            view_as: props.viewAs
        } : {};
        if (dataFilter) {
            params.dataFilter = dataFilter;
        }
        let obj = {
            offset:0,
            limit:10,
            section,
            card_name: props.searchText ? props.searchText:"",
        }
        if (props.startDate && props.endDate) {
            obj = {
                ...obj,
                startDate: toISODate(props.startDate),
                endDate: toISODate(props.endDate),
                selectedDueDate: props.selectedDueDate
            }
        }
        axiosClient.post("/api/getCards", { ...params, ...obj })
        .then(({ data }) => {
            if (data[dataSection] && data[dataSection].length !== 0) {
                setCardData(data[dataSection]);
            } else {
                setCardData([]);
            }
        })
        .catch(error => {
            console.error("Failed to fetch cards:", error);
            setCardData([]); 
        });
    }

    const handleFilterClick = (type) => {
        if (type === 'down') {
            setIconState({ up: true, down: false, reset: true });
            filterCardByDate('down'); // Pass 'down' as a parameter
        } else if (type === 'up') {
            setIconState({ up: false, down: true, reset: true });
            filterCardByDate('up'); // Pass 'up' as a parameter
        } else {
            setIconState({ up: false, down: true, reset: false });
            filterCardByDate(); // Call refresh without parameters
        }
    }

    return (
        <>
        <KanbanFilters iconState={iconState} onFilterClick={handleFilterClick} section={section} className='filtersIconKanban' />
        <CollapsibleItem
            className="cardList"
            expanded={true}
            header={props.name}
            icon={<Icon>arrow_drop_down</Icon>}
            node="div"
            onSelect={() => { }}
            style={{ overflowX: "scroll" }}
        >
            {!cardData &&
                <div style={{ textAlign: "center", marginTop: "22px" }}>
                    <Spin />
                </div>
            }
            {cardData && <InfiniteScroll
                pageStart={0}
                hasMore={hasMore}
                useWindow={false}
                loadMore={fetchMoreCards}
            >
                <div
                    ref={setDroppableRef}
                    className={`drag-container ${isColumnHovered ? 'drag-container-hovered' : ''}`}
                    data-droppable-id={droppableId}
                    data-card-status={props.type}
                    data-card-repurpose-status={props.rType}
                    data-ythelper-card-status={props.ytType}
                    style={{ minHeight: "10vh", minWidth: "300px" }}
                >
                    <SortableContext
                        items={displayCards?.map((c) => String(c.card_id)) || []}
                        strategy={verticalListSortingStrategy}
                    >
                        {displayCards && displayCards.map((card, index) => {
                            const ytStatus = props?.section === YT_HELPER_SECTION ? (card.ytHelper_card_status ? card.ytHelper_card_status : props.ytType) : null;
                            const showPlaceholderBefore = shouldShowPlaceholder && placeholderIndex !== null && index === placeholderIndex;
                            const cardWithYt = ytStatus != null ? { ...card, ytHelper_card_status: ytStatus } : card;
                            return (
                                <React.Fragment key={`card-wrapper-${card.card_id}`}>
                                    {showPlaceholderBefore && activeCard && (
                                        <div className="drag-placeholder-card" style={{ marginBottom: 0, marginTop: 0 }}>
                                            <RequestCard
                                                setCardActivityModal={setCardActivityModal}
                                                setCardActivityData={setCardActivityData}
                                                viewCard={props.viewCard}
                                                card={activeCard}
                                                section={props?.section}
                                                setCardRepurposeModal={setCardRepurposeModal}
                                                setCurrentCardId={setCurrentCardId}
                                                currentCardRepurpose={currentCardRepurpose}
                                            />
                                        </div>
                                    )}
                                    <DraggableCard key={`card-${card.card_id}`} card={cardWithYt} index={index} droppableId={droppableId}>
                                        <RequestCard
                                            setCardActivityModal={setCardActivityModal}
                                            setCardActivityData={setCardActivityData}
                                            viewCard={props.viewCard}
                                            card={card}
                                            section={props?.section}
                                            setCardRepurposeModal={setCardRepurposeModal}
                                            setCurrentCardId={setCurrentCardId}
                                            currentCardRepurpose={currentCardRepurpose}
                                        />
                                    </DraggableCard>
                                </React.Fragment>
                            );
                        })}
                        {shouldShowPlaceholder && placeholderIndex !== null && placeholderIndex === displayCards.length && activeCard && (
                            <div className="drag-placeholder-card" style={{ marginBottom: 0, marginTop: 0 }}>
                                <RequestCard
                                    setCardActivityModal={setCardActivityModal}
                                    setCardActivityData={setCardActivityData}
                                    viewCard={props.viewCard}
                                    card={activeCard}
                                    section={props?.section}
                                    setCardRepurposeModal={setCardRepurposeModal}
                                    setCurrentCardId={setCurrentCardId}
                                    currentCardRepurpose={currentCardRepurpose}
                                />
                            </div>
                        )}
                    </SortableContext>
                </div>
            </InfiniteScroll>}
        </CollapsibleItem>
        <Modal
            header={"Card Activity"}
            id="cardActivityModal"
            open={cardActivityModal}
            style={{height: '60%'}}
            options={{
                dismissible: true,
                endingTop: '10%',
                opacity: 0.5,
                preventScrolling: true,
                onCloseEnd: () => {setCardActivityModal(false)}
            }}
        >
            <Container style={{ backgroundColor: '#F6F7F7'}}>
                {
                    cardActivityData?.length > 0 ?
                    cardActivityData?.map(item => {
                        return  <div>
                                    <Row className="row-card-activity">
                                            <Col s={4} className="col-card-activity">
                                                <div className="card-activity-initials">
                                                    <span>{item.user_id === 0 ? "AM" : item.firstname?.charAt(0) + item.lastname?.charAt(0)}</span>
                                                </div>
                                                <div>
                                                    <span className='card-activity-primary-text'>{item.user_id === 0 ? "Auto Movement" : item.firstname + " " + item.lastname}</span><br />
                                                    <span className='card-activity-secondary-text' style={{ textTransform: 'capitalize' }}>{item.client_type}</span>
                                                </div>
                                            </Col>
                                            <Col s={8}>
                                                <span className='card-activity-primary-text' dangerouslySetInnerHTML={{ __html: item.card_activity_status }}></span><br />
                                                <span className='card-activity-secondary-text'>{convertServerToLocalTime(item.created_at)}</span>
                                            </Col>
                                        </Row>
                                </div>
                    }) :  <div className='empty-card-activity'>
                                <p>No Activity is Present</p>
                                <img src={EmptyIcon} alt="Empty Icon" />
                            </div>
                }
            </Container>
        </Modal>
        <EnableRepurpose cardRepurposeModal={cardRepurposeModal} setCardRepurposeModal={setCardRepurposeModal} currentCardId={currentCardId} setCurrentCardRepurpose={setCurrentCardRepurpose}/>
        </>
    );
};
